import CloseIcon from '@mui/icons-material/Close'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { IconButton, SvgIcon, useTheme } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import makeStyles from '@mui/styles/makeStyles'
import React, { useState } from 'react'
import AfterPayIcon from '@icons/AfterPayIcon'
import LogoAfterPayLarge from 'images/afterpay/logo_afterpay_large.svg'
import Logo1 from 'images/afterpay/logo_afterpay_modal_1.svg'
import Logo2 from 'images/afterpay/logo_afterpay_modal_2.svg'
import Logo3 from 'images/afterpay/logo_afterpay_modal_3.svg'
import Logo4 from 'images/afterpay/logo_afterpay_modal_4.svg'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Trans, useTranslation } from 'react-i18next'
import { AFTER_PAY_TERMS_URL } from '../../urls'

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    color: '#9a9a9a',
    marginLeft: '5px',
  },
}))

interface Props {}

const AfterPayButton: React.FC<Props> = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const theme = useTheme()
  const smDown = useMediaQuery(theme.breakpoints.down('sm'))
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <span className={classes.wrapper}>
        <SvgIcon component={AfterPayIcon} viewBox='0 0 85 20' sx={{ width: '85px', height: '20px' }} />
        <HelpOutlineOutlinedIcon className='cursor-help pb-2' onClick={() => setIsOpen(true)} />
      </span>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)} maxWidth='lg' fullScreen={smDown}>
        <DialogTitle>
          <span className='inline-block' />
          <span className='absolute right-10 top-10'>
            <IconButton onClick={() => setIsOpen(false)} size='medium' title='Close'>
              <CloseIcon fontSize='large' />
            </IconButton>
          </span>
        </DialogTitle>

        <DialogContent className='w-700 max-w-full'>
          <div className='flex items-center flex-col'>
            <img src={LogoAfterPayLarge} alt='Logo AfterPay' width='200' height='60' />
            <div className='mt-10 mb-40 text-32 leading-tight font-bold'>
              {t('shopNowPayLater', 'Shop now. Pay later.')} <br /> {t('alwaysInterestfree', 'Always interest-free')}
            </div>
            <div className='flex flex-col sm:flex-row justify-between items-center sm:items-baseline mb-50'>
              <div className='flex-1'>
                <div className='flex justify-center mb-16'>
                  <img src={Logo1} alt='Afterpay modal logo 1' width='44' height='61' />
                </div>
                <p className='text-center text-base sm:text-sm font-bold mx-12'>
                  {t('addYourFavoritesToCart', 'Add your favorites to cart')}
                </p>
              </div>
              <div className='flex-1'>
                <div className='flex justify-center mb-16'>
                  <img src={Logo2} alt='Afterpay modal logo 2' width='68' height='46' />
                </div>
                <p className='text-center text-base sm:text-sm font-bold mx-12'>
                  {t('selectAfterpayAtCheckout', 'Select Afterpay at checkout')}
                </p>
              </div>
              <div className='flex-1'>
                <div className='flex justify-center mb-16'>
                  <img src={Logo3} alt='Afterpay modal logo 3' width='68' height='46' />
                </div>
                <p className='text-center text-base sm:text-sm font-bold mx-12'>
                  {t(
                    'loginOrCreateAfterPayAccount',
                    'Log into or create your Afterpay account, with instant approval decision'
                  )}
                </p>
              </div>
              <div className='flex-1'>
                <div className='flex justify-center mb-16'>
                  <img src={Logo4} alt='Afterpay modal logo 4' width='58' height='58' />
                </div>
                <p className='text-center text-base sm:text-sm font-bold mx-12'>
                  {t('afterPaySplitPayments', 'Your purchase will be split into 4 payments, payable every 2 weeks')}
                </p>
              </div>
            </div>
            <div className='text-sm sm:text-xs w-600 max-w-full leading-tight text-center'>
              <Trans i18nKey='afterPayTerms'>
                <div>
                  You must be over 18, a resident of the U.S. and meet additional eligibility criteria to qualify. Late
                  fees may apply. Estimated payment amounts shown on product pages exclude taxes and shipping charges,
                  which are added at checkout.
                </div>
                <div>
                  Click{' '}
                  <a href={AFTER_PAY_TERMS_URL} rel='noreferrer noopener' target='_blank'>
                    here
                  </a>{' '}
                  for complete terms.
                </div>
                <div>
                  Loans to California residents made or arranged pursuant to a California Finance Lenders Law license.
                </div>
                <div>©2020 Afterpay</div>
              </Trans>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default AfterPayButton
